import './App.css';
import { Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import 'dayjs/locale/th';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

// pages
import P404 from '@/containers/pages/404';
// sellers
import SellerInvoiceSearch from '@/containers/seller/invoice';
import SellerBillingSearch from '@/containers/seller/billing';
import SellerPaymentSearch from '@/containers/seller/payment';
// buyers
import BuyerInvoiceSearch from '@/containers/buyer/invoice';
import BuyerBillingSearch from '@/containers/buyer/billing';
import BuyerPaymentSearch from '@/containers/buyer/payment';
// portal
import Portal from './containers/pages/portal';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.locale('th'); // use locale

function App() {
  return (
    <div className="p-4">
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimaryHover: 'currentColor', // Set hover primary color
            },
            Table: {
              headerBg: '#fff',
            },
          },
        }}
      >
        <Routes>
          <Route path="/" element={<P404 />} />
          <Route path="/route" element={<Portal />} />
          <Route
            path="/seller-invoice-inquiry"
            element={<SellerInvoiceSearch />}
          />
          <Route
            path="/seller-billing-inquiry"
            element={<SellerBillingSearch />}
          />
          <Route
            path="/seller-payment-inquiry"
            element={<SellerPaymentSearch />}
          />
          <Route
            path="/buyer-invoice-inquiry"
            element={<BuyerInvoiceSearch />}
          />
          <Route
            path="/buyer-billing-inquiry"
            element={<BuyerBillingSearch />}
          />
          <Route
            path="/buyer-payment-inquiry"
            element={<BuyerPaymentSearch />}
          />
        </Routes>
      </ConfigProvider>
    </div>
  );
}

export default App;
